import { getAxios, postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { getInvoiceCooltraMock, getInvoiceMock, getTicketMock } from "./MyPastTrips.mock";
import { formatDateAndMonthToLiteral, formatCompleteDateToLiteral, invoiceModalButtonLiterals } from "./MyPastTrips.util";

//Invoice Call Mocked
export function InvoicesCall(idBook: string, originDate: string, destinationDate: string, referenceId: string, callback: Function, errorCallback: Function, mock?: string) {
  if (mock == "true") {
    callback(getInvoiceCooltraMock())
  } else {
    getAxios(apiNames.FINANCIAL, true, `/invoices/${idBook}?originDate=${originDate}&destinationDate=${destinationDate}&referenceId=${referenceId}`).then((data: any) => {
      callback(data);
    }).catch((error: any) => {
      errorCallback(error)
    })
  }
}


//Tickets Call Mocked
export function TicketsCall(id: string, callback: Function, errorCallback: Function, data: Object) {
  return postAxios(apiNames.FINANCIAL, true, `/tickets/orderId/${id}`, data).then((data: any) => {
    callback(data);
  }).catch((error: any) => {
    errorCallback(error)
  })
}

export function RefreshBookStatus(id: string, callback: Function, errorCallback: Function, data: Object) {
  //const url = `/tickets/orderId/${id}`    
  return postAxios(apiNames.BKING, true, `/journeys/refresh/${id}`, data).then((data: any) => {
    callback(data);
  }).catch((error: any) => {
    errorCallback(error)
  })
}

// export function TicketsCall(id: string, callback: Function, errorCallback: Function) {
//   //const url = `/tickets/orderId/${id}`
//   return getAxios(apiNames.FINANCIAL, true, `/tickets/orderId/O-0001LP`).then((data: any) => {
//     callback(data);
//   }).catch((error: any) => {
//     errorCallback(error)
//   })
// }



//Invoice Modal Functions
export function getFilterInvoiceModal(data: any) {
  let mappedFilter: any = [];
  mappedFilter = [];
  data.forEach((elem: any) => {
    if ((!elem.icon.includes("andar") && (!elem.icon.includes("metro")))) {
      if (elem.icon.includes("ave") && filterExists(mappedFilter, "renfe")) mappedFilter.push({ "code": "renfe", "text": "Renfe" })
      else if (elem.icon.includes("moto") && filterExists(mappedFilter, "cooltra")) mappedFilter.push({ "code": "cooltra", "text": "Cooltra", "info": elem.tripId, "line": elem.line })
      else if (elem.icon.includes("cercanias") && filterExists(mappedFilter, "cercanias")) mappedFilter.push({ "code": "cercanias", "text": "Cercanias" })
      else if (elem.icon.includes("patinete") && filterExists(mappedFilter, "reby")) mappedFilter.push({ "code": "tier", "text": "Tier", "info": elem.tripId, "line": elem.line })
      else if (elem.icon.includes("taxi")) {
        if (elem.line.text.includes("Movitaxi") && filterExists(mappedFilter, "movitaxi"))
          mappedFilter.push({ "code": "movitaxi", "text": "Movitaxi" })
        else if (elem.transportTypeString.includes("Bolt")) {
          mappedFilter.push({ "code": "bolt", "text": "Bolt" })
        }
        else {
          if (filterExists(mappedFilter, "karhoo")) {
            //cambiar este nombre conjunto con el nombre de la etiqueta
            mappedFilter.push({ "code": "taxiVtc", "text": "Taxi/VTC" })
          }
        }
      }
    }

  })


  return mappedFilter;
}

function filterExists(FilterArray: any, key: string) {

  if (FilterArray.length == 0) {
    return true
  } else {
    if (FilterArray.find((element: any) => element.code === key)) return false
    else return true
  }
}

/**
 * Función padre para mapear tarjetas de facturas de  ida y ida/vuelta
 * @param dataCard 
 * @param t 
 * @returns 
 */
export function getCardsInvoiceModal(dataCard: any, t: any) {
  const result = {
    result: invoiceCardMapping(dataCard.outwardJourney, t).concat(invoiceCardMapping(dataCard.returnJourney, t))
  }

  return result;
}


export function prepareDataForTickets(data: any) {
  const bodyforTickets: any[] = [];
  // CONTRATOS: Entiendo que se tiene que hacer un filter de los tickets que tengan los valores {type: mode, value: complex}
  if (data.event != "cercanias") {
    data?.bookings?.forEach((ticket: any) => {
      if (ticket?.status != "CANCELED") {
        bodyforTickets.push(ticket?.ticketId);
      }
    });
  } else {
    data?.bookings?.forEach((ticket: any) => {
      bodyforTickets.push(ticket?.ticketId);
    });
  }

  return bodyforTickets;

}

//Descomentar lo del nombre y apellido cuando nos llegue del back
export function prepareAvePassengersForModal(travellers: any, passBooks: any) {
  const avepassengers: any = []

  travellers.forEach((person: any, index: any) => {
    const name = person?.personalInformation?.customerFullName?.name;
    const surname = person?.personalInformation?.customerFullName?.firstSurname;
    //const isCanceled = passBooks.some((passBook:any) => passBook.idBook === person.bookID);
    let isCanceled = false;
    if (person?.status === "BOOKED") {
      isCanceled = true
    }
    const personalTicket = passBooks.find((passBook: any) => passBook.idBook === person.bookID)

    avepassengers.push({ 'id': index, fullname: name + " " + surname, ticketId: personalTicket?.passBook, disable: !isCanceled })
  });

  return avepassengers
}

export function prepareCercaniasPassengersForModal(travellers: any, tickets: any, id: any) {
  const cercaniaspassengers: any = [];
  // let adultcount = 0; 
  // let childcount = 0; 
  let ticketcount = 0;


  travellers.forEach((person: any, index: any) => {
    const personalTicket = tickets.find((ticket: any) => ticket.idBook === person.bookID)

    ++ticketcount;
    cercaniaspassengers.push({ code: index, id: id, text: 'Billete ' + ticketcount, ticketId: personalTicket })
    // if(person.type == 'ADULT'){
    //   adultcount++;
    //   cercaniaspassengers.push({code: index, text: 'Adulto '+ adultcount, ticketId: personalTicket})
    // }else if(person.type == 'CHILD'){
    //   childcount++; 

    // }
  });
  return cercaniaspassengers
}

export function transformTicket(tickets: any, passengersWithTicket: any, orderId?: string) {

  const cercaniastickets: any = []

  passengersWithTicket.map((passenger: any) => {

    const { issuedDate, printingDate, qrCodeText } = passenger.ticketId;

    const newissuedData = formatCompleteDateToLiteral(issuedDate);
    const newprintingDate = formatCompleteDateToLiteral(printingDate);
    const newqrCodeText = "data:image/png;base64," + qrCodeText;

    cercaniastickets.push({
      ...passenger.ticketId,
      issuedDate: newissuedData,
      printingDate: newprintingDate,
      qrCodeText: newqrCodeText,
      orderId
    })
  })

  // tickets.forEach((ticket:any) => {
  //   const {issuedDate, printingDate, qrCodeText} = ticket; 
  //   const newissuedData = formatCompleteDateToLiteral(issuedDate);
  //   const newprintingDate = formatCompleteDateToLiteral(printingDate);
  //   const newqrCodeText = "data:image/png;base64,"+ qrCodeText;
  //   cercaniastickets.push({...ticket, issuedDate: newissuedData,
  //     printingDate: newprintingDate,
  //     qrCodeText: newqrCodeText})
  // });

  //   {
  //     idBook: "Y2VyY2FuaWFzfGlkfDAuMXwxbGVINWNwMll5OFVZNjlVRmNUcU9nPT18eyJpZCI6IktDNUtWMzQifQ==",
  //     locationCode: "KC5KV34",
  //     issuedDate: "2022-09-09T00:00:00+02:00",
  //     printingDate: "2022-10-09T00:00:00+02:00",
  //     qrCodeText: "data:image/png;base64,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",
  //     canceled: false
  // },

  return cercaniastickets;

}



export function base64toBlob(data: string) {


  const bytes = atob(data);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }

  return new Blob([out], { type: 'application/pdf' });
};

export function downloadBlob(blob: any, name = 'file.txt') {
  // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
  const blobUrl = URL.createObjectURL(blob);

  // Create a link element
  const link = document.createElement("a");

  // Set link's href to point to the Blob URL
  link.href = blobUrl;
  link.download = name;

  // Append link to the body
  document.body.appendChild(link);

  // Dispatch click event on the link
  // This is necessary as link.click() does not work on the latest firefox
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    })
  );

  // Remove link from body
  document.body.removeChild(link);
}
export function openConditionsLink(t: any) {
  window.open(t("urlCondiciones"), '_blank');
  //window.open('https://www.renfe.com/es/es/informacion-legal/sociedades/viajeros/tipos-trenes/condiciones-generales-cercanias/informacion-general-cercanias', '_blank');
}


/**
 * Funcion para mapear las tarjetas de la factura
 * @param dataCard 
 * @param t 
 * @returns 
 */
export function invoiceCardMapping(dataCard: any, t: any) {
  const generatedCards: any = [];
  dataCard?.forEach((elem: any) => {
    if (elem.icon.includes("moto")) {
      generatedCards.push({
        literals: {
          button: invoiceModalButtonLiterals(t).downloadInvoice,
        },
        idcard: elem.orderId,
        idbutton: "downloadInvoice",
        color: elem.line.color,
        text: elem.line.text.charAt(0).toUpperCase() + elem.line.text.slice(1),
        date: formatDateAndMonthToLiteral(elem.trip.Origin.date),
        hour: elem.trip.Origin.time.slice(0, -3)

      })
    } else if (elem.icon.includes("bici")) {
      generatedCards.push({
        literals: {
          button: invoiceModalButtonLiterals(t).sendForm,
        },
        idbutton: "sendForm",
        idcard: elem.orderId,
        color: elem.line.color,
        text: elem.line.text,
        date: formatDateAndMonthToLiteral(elem.trip.Origin.date),
        hour: elem.trip.Origin.time.slice(0, -3)
      })
    } else if (elem.icon.includes("ave")) {
      generatedCards.push({
        literals: {
          button: invoiceModalButtonLiterals(t).accesForm,
        },
        idcard: elem.orderId,
        idbutton: "accesForm",
        color: elem.line.color,
        text: elem.line.text + elem.trip.Destination.extId,
        mode: elem.pricetag.text,
        origin: elem.stops[0],
        destination: elem.direction,
        date: formatDateAndMonthToLiteral(elem.trip.Origin.date),
        hour: elem.trip.Origin.time.slice(0, -3),
        invoiceDownloadUrl: 'https://www.renfe.com/es/es/ayuda/solicitar-factura/formulario-factura'

      })
    } else if (elem.icon.includes("taxi")) {
const providerConfig = {
  Movitaxi: {
    color: "#58830B",
    tagText: (elem:any) => elem.line.text,
    cardText: (elem:any) => elem.line.text
  },
  Freenow: {
    color: "#B4282E",
    tagText: (elem:any) => elem.line.text,
    cardText: () => "Taxi/VTC"
  },
  Bolt: {
    color: "#2D8659",
    tagText: (elem:any) => elem.line.text,
    cardText: (elem:any) => elem.line.text
  }
} as any

const lineText = elem?.line?.text
const config = providerConfig[lineText]

if (config) {
  const color = config.color

  generatedCards.push({
    literals: {
      button: invoiceModalButtonLiterals(t).downloadInvoice,
      urlButton: invoiceModalButtonLiterals(t).urlContact
    },
    idcard: elem.orderId,
    idbutton: "downloadInvoice",
    color,
    text: config.cardText(elem),
    mode: elem.pricetag?.text,
    origin: elem.stops[0],
    destination: elem.direction,
    date: formatDateAndMonthToLiteral(elem.trip.Origin.date),
    hour: elem.trip.Origin.time.slice(0, -3),
    tag: {
      text: config.tagText(elem),
      color: "white",
      backgroundcolor: color,
      bordercolor: color.replace("#", "") // o simplemente color, según cómo lo uses
    },
    invoiceDownloadUrl: elem?.orderId?.bookings?.[0]?.invoiceDownloadUrl || null
  })
}

    }
  })
  return generatedCards;
}





